module.exports = __webpack_public_path__ + "static/aus-gold-1c578dbfc340feb3f0c6f9491ce6409d.jpg";